import { Component, OnInit, Input } from '@angular/core';
import { Book } from '../../../../../../shared/models/book';
import { EditorService } from '../../../../../bookeditoption/editor.service';
@Component({
  selector: 'app-audiomedia',
  templateUrl: './audiomedia.component.html',
  styleUrls: ['./audiomedia.component.css']
})
export class AudiomediaComponent implements OnInit {
  @Input() data: any;
  public bookObj: Book;
  audioDataUrl;
  constructor(private editorService: EditorService) { }

  ngOnInit() {
    this.bookObj = this.data.popupProps.curComp.bookObj;
    let cardData = this.editorService.textInlineData;
    if (cardData && cardData.type == "AUDIO") {
      this.initializeData(cardData);
    }
  }
  initializeData(cardData) {
    if (cardData.props && cardData.props.audioFile && cardData.props.audioFile.url) {
      this.audioDataUrl = cardData;
    }
  }
  addAudioUrl(audioUrl) {
    let layer = this.editorService.getIframeReference();
    layer.updateAudioSrc(audioUrl.url, audioUrl.type);
  }
}



// WEBPACK FOOTER //
// ./src/app/bookShared/bookeditoption/bookEditOptionPopups/media/audio/audiomedia/audiomedia.component.ts